import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LegalTabs } from "@/components/legal/LegalTabs";
import { LegalAcceptBar, useLegalStatus } from "@/components/legal/LegalAccept";
import { LegalAttestations } from "@/components/legal/LegalAttestations";

/** Page « Informations légales » partagée par les portails chef & salarié (lecture + acceptation + attestations). */
export function PortalLegalPage({ portal, onAccepted: onAcceptedExternal }) {
  const [params, setParams] = useSearchParams();
  const current = params.get("doc") || (portal === "chef" ? "cgv" : portal === "bp" ? "bp_rules" : "cgu");
  const legal = useLegalStatus();
  const [attKey, setAttKey] = useState(0);
  const onAccepted = (data) => { legal.apply(data); setAttKey((k) => k + 1); onAcceptedExternal?.(data); };
  return (
    <div className="p-6 lg:p-10 space-y-6" data-testid={`${portal}-legal-page`}>
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-bold mb-2">// Transparence</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Informations légales</h1>
        <p className="text-sm text-[#495057] mt-2">Mentions légales, conditions générales de vente et d'utilisation, politique de confidentialité — versions en vigueur.</p>
        {legal.pending.length > 0 && (
          <div className="mt-4 border-2 border-[#FFD700] bg-[#FFFBEB] px-4 py-3 text-xs" data-testid="legal-pending-banner">
            <b>{legal.pending.length} document(s) à accepter</b> : {legal.pending.map((k) => legal.status[k]?.title).join(", ")}.
          </div>
        )}
      </div>
      <LegalTabs current={current} onChange={(k) => setParams({ doc: k })} status={legal.status}
        renderExtra={(doc) => <LegalAcceptBar doc={doc} status={legal.status} onAccepted={onAccepted} />} />
      <LegalAttestations refreshKey={attKey} />
    </div>
  );
}
